import { Text } from "@mantine/core";
import { useEffect } from "react";
import { match, P } from "ts-pattern";
import { AnalysisTable } from "@/components/admin/analysis/AnalysisTable";
import { ExecuteAnalysisButton } from "@/components/admin/analysis/ExecuteAnalysisButton";
import PageHeader from "@/components/admin/header/PageHeader";
import { useAnalyses } from "@/hooks/useAnalyses";
import { useAnalysisTotalVocCharCount } from "@/hooks/useAnalysisTotalVocCharCount";
import { useCategoryTrees } from "@/hooks/useCategoryTrees";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { showError } from "@/utils/notification";

const ExecuteAnalysisPage = () => {
  const { categoryTrees, getCategoryTreeVersion } = useCategoryTrees();
  const { analyses, error: fetchAnalysesError, isLoading: isLoadingAnalyses, isAnalysisRunning } = useAnalyses();
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { totalVocCharCount, error: fetchTotalVocCharCountError } = useAnalysisTotalVocCharCount(
    sessionCurrentWorkspaceId,
  );

  useEffect(() => {
    if (fetchAnalysesError) showError("分析一覧の取得に失敗しました。");
  }, [fetchAnalysesError]);

  useEffect(() => {
    if (fetchTotalVocCharCountError) showError("累計VoC文字数の取得に失敗しました。");
  }, [fetchTotalVocCharCountError]);

  return (
    <>
      <PageHeader hasBack={false} title="分析" />
      <h2 style={{ marginTop: 0 }}>分析実行履歴</h2>
      <Text size="sm" c="dimmed" mb="md">
        累計VoC文字数: {totalVocCharCount === undefined ? "-" : `${totalVocCharCount.toLocaleString()} 文字`}
      </Text>
      {analyses && (
        <AnalysisTable
          analyses={analyses}
          isLoading={isLoadingAnalyses}
          getCategoryTreeVersion={getCategoryTreeVersion}
        />
      )}

      <h2>分析実行</h2>
      {match(categoryTrees)
        .with(undefined, () => <></>)
        .with(P.when((categoryTrees) => categoryTrees.length === 0), () => "カテゴリが作成されていません")
        .otherwise((categoryTrees) => (
          <ExecuteAnalysisButton categoryTrees={categoryTrees} isAnalysisRunning={isAnalysisRunning} />
        ))}
    </>
  );
};

export default ExecuteAnalysisPage;
